export const getSearchParams = () => {
    return new URL(document.location.href).searchParams;
};
